import { useQuery } from '@tanstack/react-query';
import { fetchCarePlans } from '../api/carePlansApi';

export const carePlansKeys = {
  all: ['care-plans'] as const,
};

export function useCarePlans(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: carePlansKeys.all,
    queryFn: fetchCarePlans,
    staleTime: 5 * 60 * 1000,
    enabled: options?.enabled ?? true,
  });
}
